module.exports = __webpack_public_path__ + "static/logo-suze-90bcfde0f2afcaef274cb7adb32726e7.svg";